
    import '/home/ec2-user/Youlify-Design/components/warning-banner/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["warning-banner-demo-basic"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/home/ec2-user/Youlify-Design/components/warning-banner/index.en-US.md?type=demo')
};